// @ts-nocheck
import {faArrowLeft, faCalendar, faClock, faPaw} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {generateAnimalitosDayResults, getTodayFormatted} from "../utils/generateLotteryData";
import * as styles from "./_lovenPagesCls";

const Animalitos = () => {
  const navigate = useNavigate();
  const [results, setResults] = useState([]);

  useEffect(() => {
    // Generate all day results on component mount
    setResults(generateAnimalitosDayResults());
  }, []);

  return (
    <div className={styles.pageContainerCls}>
      <button
        type="button"
        className={styles.backButtonCls}
        onClick={() => navigate("/lotoven/home")}
      >
        <FontAwesomeIcon icon={faArrowLeft} />
        <span>Volver</span>
      </button>

      <div className={styles.headerCls}>
        <div className={styles.headerIconCls}>
          <FontAwesomeIcon icon={faPaw} />
        </div>
        <h1 className={styles.titleCls}>Resultados Animalitos</h1>
        <div className={styles.dateContainerCls}>
          <FontAwesomeIcon
            icon={faCalendar}
            className={styles.calendarIconCls}
          />
          <p className={styles.dateCls}>{getTodayFormatted()}</p>
        </div>
      </div>

      {/* Description */}
      <div className={styles.descriptionBoxCls}>
        <p>
          Resultados de todos los sorteos de Animalitos del día de hoy. Los sorteos se realizan cada hora desde las 9:00
          AM hasta las 7:00 PM.
        </p>
      </div>

      {/* Results Grid */}
      <div className={styles.animalitoGridFullCls}>
        {results.map((result, index) => (
          <div
            key={`animalito-${index++}`}
            className={styles.animalitoCardCls}
          >
            <div className={styles.cardHeaderCls}>
              <FontAwesomeIcon
                icon={faClock}
                className={styles.clockIconCls}
              />
              <span className={styles.cardTimeCls}>{result.time}</span>
            </div>
            <div className={styles.cardBodyCls}>
              <div className={styles.animalNumberLargeCls}>{result.result.number}</div>
              <div className={styles.animalNameLargeCls}>{result.result.name}</div>
            </div>
            <div className={styles.cardFooterCls}>
              <span className={styles.cardDateCls}>{result.date}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Info Banner */}
      <div className={styles.infoBannerCls}>
        <p>🐾 Los Animalitos son una tradición venezolana basada en 37 animales numerados del 00 al 36</p>
      </div>
    </div>
  );
};

export default Animalitos;
